import { httpManager as http } from '@/common/js/HttpManager';
import { config } from 'CONFIG';

export const getStorageSub = () => {

    return new Promise(( resolve, reject ) => {

        http.get( `/users/@me/storage-subscription/` ).then( res => {

            resolve( res.data );
        
        }).catch( err => {

            if ( err.response.data.error.code === 32782 ) {

                resolve( null );

            } else {

                reject( err );

            }
            
        });

    });

};

export const getPlanList = () => {

    return new Promise(( resolve, reject ) => {

        http.get( `/shop/products/?type=cloud_storage_plan&client_id=${encodeURIComponent( config.clientId )}` ).then( res => {

            resolve( res.data );
        
        }).catch( err => {

            reject( err );
            
        });

    });

};



// WEBPACK FOOTER //
// ./src/api/dashboard.js